import AveDataChannel from './ave-data-channel.js';
import { startNegotiation } from './negotiation.js';
export async function establishPeerConnection(props) {
    const logger = props.logger;
    const rtcConfiguration = await props.signalingChannel.getRTCConfiguration();
    const peerConnection = new RTCPeerConnection(rtcConfiguration);
    setupOnTrackHandler(peerConnection, props);
    const peerConnectionPromise = waitForConnectedState(peerConnection, logger)
        .then()
        .catch((error) => {
        peerConnection.ontrack = null;
        peerConnection.close();
        throw error;
    });
    setupTransceivers(peerConnection, props);
    const dataChannelPromise = AveDataChannel.open(peerConnection, props);
    startNegotiation(peerConnection, props);
    return { peerConnection: await peerConnectionPromise, dataChannel: await dataChannelPromise };
}
const waitForConnectedState = (peerConnection, logger) => new Promise((resolve, reject) => {
    peerConnection.onconnectionstatechange = (event) => {
        logger.debug('PeerConnection connection state change', {
            state: peerConnection.connectionState,
            event
        });
        if (['connected'].includes(peerConnection.connectionState)) {
            peerConnection.onconnectionstatechange = null;
            resolve(peerConnection);
        }
        if (['failed', 'closed'].includes(peerConnection.connectionState)) {
            peerConnection.onconnectionstatechange = null;
            reject(new Error(`Could not establish peer connection. State ${peerConnection.connectionState}`));
        }
    };
});
function setupOnTrackHandler(peerConnection, props) {
    peerConnection.ontrack = (rtcTrackEvent) => {
        props.logger.debug(`PeerConnection received new track`, {
            kind: rtcTrackEvent.track.kind,
            id: rtcTrackEvent.track.id,
            readyState: rtcTrackEvent.track.readyState
        });
        if (rtcTrackEvent.track.kind === 'video') {
            if (props.dataChannelOnly) {
                props.logger.debug(`Using datachannel only, ignoring track ${rtcTrackEvent.track.id}`);
                // Note: Stopping transceivers also stops them for all other connected users.
                // Therefore, we just ignore the video track in dataChannelOnly instead of stopping it.
                // This is most likely a bug in the Unreal Engine and needs to be fixed there.
            }
            else {
                props.logger.debug(`Setting track to HTML video elements, track ${rtcTrackEvent.track.id}`);
                props.playerHtmlContainers?.setVideoStream(rtcTrackEvent.streams[0]);
            }
        }
        else if (rtcTrackEvent.track.kind === 'audio') {
            props.logger.debug(`Stopping audio track ${rtcTrackEvent.track.id}`);
            rtcTrackEvent.transceiver.stop();
        }
        else {
            props.logger.debug('Skip setting track to video element');
        }
    };
}
function setupTransceivers(peerConnection, props) {
    if (props.dataChannelOnly) {
        props.logger.debug('No special transceiver setup for dataChannel only mode');
        // Note: Stopping transceivers also stops them for all other connected users.
        // Therefore, we just ignore the video track in dataChannelOnly instead of stopping it.
        // This is most likely a bug in the Unreal Engine and needs to be fixed there.
        return;
    }
    if (peerConnection.getTransceivers().length === 0) {
        props.logger.debug('PeerConnection has no receivers, adding audio/video');
        peerConnection.addTransceiver('video', { direction: 'recvonly' });
        peerConnection.addTransceiver('audio', { direction: 'recvonly' });
    }
}
//# sourceMappingURL=peer-connection.js.map